import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function TermsPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2">Termos de Uso</h1>
          <p className="text-muted-foreground">
            Última atualização: {new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })}
          </p>
        </div>

        <Card>
          <CardContent className="pt-6 space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Aceitação dos Termos</h2>
              <p className="text-muted-foreground leading-relaxed">
                Ao acessar e usar a plataforma FotUP, você concorda em cumprir e estar vinculado aos seguintes termos e condições de uso. 
                Se você não concorda com alguma parte destes termos, não deve usar nosso serviço.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. Descrição do Serviço</h2>
              <p className="text-muted-foreground leading-relaxed">
                A FotUP é uma plataforma de fotografia esportiva que conecta atletas e fotógrafos, permitindo a busca, 
                visualização e compra de fotografias de eventos esportivos. Nossos serviços incluem, mas não se limitam a:
              </p>
              <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1 ml-4">
                <li>Busca e visualização de fotografias de eventos esportivos</li>
                <li>Compra e download de fotografias</li>
                <li>Upload e gerenciamento de fotografias por fotógrafos</li>
                <li>Criação e gerenciamento de eventos esportivos</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Conta de Usuário</h2>
              <p className="text-muted-foreground leading-relaxed">
                Para usar certos recursos da plataforma, você precisará criar uma conta. Você é responsável por:
              </p>
              <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1 ml-4">
                <li>Manter a confidencialidade de suas credenciais de conta</li>
                <li>Todas as atividades que ocorrem sob sua conta</li>
                <li>Notificar-nos imediatamente sobre qualquer uso não autorizado de sua conta</li>
                <li>Fornecer informações precisas e atualizadas ao criar sua conta</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Propriedade Intelectual</h2>
              <p className="text-muted-foreground leading-relaxed">
                Todo o conteúdo da plataforma, incluindo textos, gráficos, logotipos, ícones, imagens, clipes de áudio, 
                downloads digitais e compilações de dados, é propriedade da FotUP ou de seus fornecedores de conteúdo e 
                está protegido por leis de direitos autorais e outras leis de propriedade intelectual.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Uso Aceitável</h2>
              <p className="text-muted-foreground leading-relaxed">
                Você concorda em não usar a plataforma para:
              </p>
              <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1 ml-4">
                <li>Violar qualquer lei ou regulamento aplicável</li>
                <li>Infringir direitos de propriedade intelectual de terceiros</li>
                <li>Transmitir qualquer conteúdo ofensivo, difamatório ou ilegal</li>
                <li>Interferir ou interromper o funcionamento da plataforma</li>
                <li>Tentar obter acesso não autorizado a qualquer parte da plataforma</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Pagamentos e Reembolsos</h2>
              <p className="text-muted-foreground leading-relaxed">
                Todos os pagamentos são processados de forma segura através de nossos parceiros de pagamento. 
                Os preços podem ser alterados a qualquer momento, mas as alterações não afetarão compras já confirmadas. 
                Políticas de reembolso estão disponíveis na página de Política de Privacidade.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Limitação de Responsabilidade</h2>
              <p className="text-muted-foreground leading-relaxed">
                A FotUP não será responsável por quaisquer danos diretos, indiretos, incidentais, especiais ou consequenciais 
                resultantes do uso ou incapacidade de usar nossos serviços.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">8. Modificações dos Termos</h2>
              <p className="text-muted-foreground leading-relaxed">
                Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações entrarão em vigor 
                imediatamente após a publicação. O uso continuado da plataforma após tais modificações constitui sua aceitação 
                dos novos termos.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">9. Contato</h2>
              <p className="text-muted-foreground leading-relaxed">
                Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco através de nossa página de Contato.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

